import { render, staticRenderFns } from "./td-number.vue?vue&type=template&id=2b2e42ce&"
import script from "./td-number.vue?vue&type=script&lang=js&"
export * from "./td-number.vue?vue&type=script&lang=js&"
import style0 from "./td-number.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports